import { c as _c } from "react/compiler-runtime";
import { User } from "react-feather";
import { UniversalButton } from "@/components/common/UniversalButton";
import UserDropdown from "./UserDropdown";
import { UserSectionProps } from "./types";
import { useCallback } from "react";
import useClickOutside from "@/utils/hooks/useClickOutside";
const UserSection: React.FC<UserSectionProps> = t0 => {
  const $ = _c(22);
  const {
    isAuthenticated,
    showUser,
    showUserDropdown,
    setShowUserDropdown,
    handleLogout,
    isLoggingOut,
    userDropdownRef,
    setShowLoginState,
    isAuthLoading
  } = t0;
  let t1;
  if ($[0] !== setShowUserDropdown) {
    t1 = event => {
      const target = event.target as HTMLElement;
      const isUserIcon = target.closest("[data-user-icon]");
      const isDropdownLink = target.closest("a[href]");
      const isLogoutButton = target.closest("button");
      if (isUserIcon || isDropdownLink || isLogoutButton) {
        return;
      }
      setShowUserDropdown(false);
    };
    $[0] = setShowUserDropdown;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const handleClickOutside = t1;
  const dropdownRef = useClickOutside(handleClickOutside);
  let t2;
  if ($[2] !== setShowUserDropdown || $[3] !== showUserDropdown) {
    t2 = () => {
      setShowUserDropdown(!showUserDropdown);
    };
    $[2] = setShowUserDropdown;
    $[3] = showUserDropdown;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const handleDropdownToggle = t2;
  if (!showUser) {
    return null;
  }
  if (isAuthenticated) {
    const t3 = `focus:outline-none border-2 rounded-full w-8 h-8 hover:text-[#037a6a] transition-colors duration-200 ${isLoggingOut ? "opacity-50 cursor-not-allowed" : ""}`;
    let t4;
    if ($[5] !== handleDropdownToggle || $[6] !== t3) {
      t4 = <User onClick={handleDropdownToggle} type="button" data-user-icon={true} className={t3} />;
      $[5] = handleDropdownToggle;
      $[6] = t3;
      $[7] = t4;
    } else {
      t4 = $[7];
    }
    let t5;
    if ($[8] !== dropdownRef || $[9] !== handleLogout || $[10] !== setShowUserDropdown || $[11] !== showUserDropdown) {
      t5 = showUserDropdown && <div ref={dropdownRef}><UserDropdown onLogout={handleLogout} position="right" onLinkClick={() => setShowUserDropdown(false)} /></div>;
      $[8] = dropdownRef;
      $[9] = handleLogout;
      $[10] = setShowUserDropdown;
      $[11] = showUserDropdown;
      $[12] = t5;
    } else {
      t5 = $[12];
    }
    let t6;
    if ($[13] !== t4 || $[14] !== t5 || $[15] !== userDropdownRef) {
      t6 = <div className="flex text-[#777777] relative" ref={userDropdownRef}>{t4}{t5}</div>;
      $[13] = t4;
      $[14] = t5;
      $[15] = userDropdownRef;
      $[16] = t6;
    } else {
      t6 = $[16];
    }
    return t6;
  }
  let t3;
  if ($[17] !== setShowLoginState) {
    t3 = () => setShowLoginState(true);
    $[17] = setShowLoginState;
    $[18] = t3;
  } else {
    t3 = $[18];
  }
  let t4;
  if ($[19] !== isAuthLoading || $[20] !== t3) {
    t4 = <UniversalButton text="Sign-In" classNames="lg:text-xl !text-base text-dark !font-medium !py-[5px] !rounded-lg font-lora " onClick={t3} disabled={isAuthLoading} />;
    $[19] = isAuthLoading;
    $[20] = t3;
    $[21] = t4;
  } else {
    t4 = $[21];
  }
  return t4;
};
export default UserSection;